import React, { useEffect, useState } from 'react';
import { Button, Modal, Popconfirm, Table, Tag } from "antd";
import { BiCheckDouble, BiTrash } from "react-icons/bi";
import { toast } from "react-toastify";
import API_LINK from "../../../components/link/Link";
import { SiProcessingfoundation } from "react-icons/si";
import ImgsViewer from "react-images-viewer";
import * as XLSX from 'xlsx';

function DashboardDeposit() {
    const [depositData, setDepositData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [proofImage, setProofImage] = useState('');
    const [isViewImage, setIsViewImage] = useState(false);
    const [message, setMessage] = useState('');
    const [currentData, setCurrentData] = useState({});
    const [rejectOpen, setRejectOpen] = useState(false);
    const [bonusOpen, setBonusOpen] = useState(false);
    const [bonusAmount, setBonusAmount] = useState('');
    const [selectedDeposit, setSelectedDeposit] = useState(null);


    useEffect(() => {
        LoadData();
    }, []);

    const LoadData = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            if (localStorage.getItem('Role') === "Admin") {
                formdata.append("page", "LoadOrders");
            } else {
                formdata.append("page", "LoadUserOrders");
                formdata.append("userId", localStorage.getItem('UserId'));
            }

            const requestOptions = {
                method: 'POST',
                body: formdata,
                redirect: 'follow'
            };

            const response = await fetch(`${API_LINK}Orders.php`, requestOptions);
            const result = await response.json();
            if (result.status === 1) {
                setDepositData(result.data);
                setFilterData(result.data);
            } else {
                toast.error("Server Error! Please try again later.");
            }
            setIsLoading(false);
        } catch (e) {
            console.log(e);
        }
    };

    const handleSubmit = async (user, status) => {
        let toaster = toast.loading("Processing...");
        try {
            let formdata = new FormData();
            formdata.append("page", "UpdateOrderStatus");
            formdata.append("id", user.id);
            formdata.append("userId", user.userId);
            formdata.append("amount", user.totalAmount);
            formdata.append("email", user.Email);
            formdata.append("status", status);
            formdata.append("message", message);

            const requestOptions = {
                method: 'POST',
                body: formdata,
                redirect: 'follow'
            };

            const response = await fetch(`${API_LINK}Orders.php`, requestOptions);
            const result = await response.json();

            if (result.status === 1) {
                setTimeout(() => {
                    toast.update(toaster, {
                        type: "success",
                        render: "Order status has been changed successfully.",
                        isLoading: false,
                        autoClose: 3000,
                        closeButton: true
                    });
                    LoadData();
                }, 1000);
            } else {
                toast.update(toaster, {
                    type: "error",
                    render: "Server Error! Please try again later.",
                    isLoading: false,
                    autoClose: 3000,
                    closeButton: true
                });
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleSearch = (event) => {
        try {
            const search = event.target.value?.toLowerCase() || '';
            if (search) {
                const filtered = filterData.filter((item) =>
                    item?.UserName?.toLowerCase().includes(search) ||
                    item?.totalAmount?.toString().toLowerCase().includes(search) ||
                    item?.Email?.toLowerCase().includes(search)
                );
                setDepositData(filtered);
            } else {
                setDepositData(filterData);
            }
        } catch (error) {
            console.error("Search error:", error);
        }
    };

    const exportToExcel = () => {
        const modifiedData = depositData.map(({ Image, ...rest }) => rest);
        const ws = XLSX.utils.json_to_sheet(modifiedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Deposit Data');
        XLSX.writeFile(wb, 'deposits_data.xlsx');
    };

    return (
        <>
            <Modal
                open={rejectOpen}
                okText={'Reject Now'}
                onOk={async () => {
                    if (message) {
                        setRejectOpen(false);
                        setMessage("");
                        await handleSubmit(currentData, "Rejected");
                    } else {
                        toast.warn("Please enter reason first");
                    }
                }}
                title={<p>Reason of Rejection</p>}
                onCancel={() => setRejectOpen(false)}
            >
                <div className="model-form">
                    <div className="form-group">
                        <label>Reason/Message</label>
                        <textarea value={message} onChange={e => setMessage(e.target.value)}></textarea>
                    </div>
                </div>
            </Modal>
            <Modal
                open={bonusOpen}
                okText={'Add Bonus'}
                onOk={async () => {
                    if (!bonusAmount) return toast.warn("Please enter bonus amount");

                    try {
                        let formData = new FormData();
                        formData.append("page", "AddBonus");
                        formData.append("userId", selectedDeposit.userId);
                        formData.append("depositId", selectedDeposit.id);
                        formData.append("bonusAmount", bonusAmount);

                        const requestOptions = {
                            method: 'POST',
                            body: formData,
                            redirect: 'follow'
                        };

                        const response = await fetch(`${API_LINK}Orders.php`, requestOptions);
                        const result = await response.json();

                        if (result.status === 1) {
                            toast.success("Bonus added successfully!");
                            setBonusOpen(false);
                            setBonusAmount('');
                            LoadData();
                        } else {
                            toast.error("Failed to add bonus");
                        }
                    } catch (error) {
                        console.error("Add Bonus Error:", error);
                        toast.error("Something went wrong.");
                    }
                }}
                onCancel={() => {
                    setBonusOpen(false);
                    setBonusAmount('');
                }}
                title={<p>Add Bonus to Deposit</p>}
            >
                <div className="form-group">
                    <label>Bonus Amount</label>
                    <input
                        type="number"
                        className="form-control"
                        value={bonusAmount}
                        onChange={(e) => setBonusAmount(e.target.value)}
                        placeholder="Enter bonus amount"
                    />
                </div>
            </Modal>


            <ImgsViewer
                imgs={[{ src: proofImage }]}
                isOpen={isViewImage}
                onClose={() => setIsViewImage(false)}
            />

            <div className="dashboard-content-container">
                <div className="dashboard-content">
                    <div className="dashboard-content-title">
                        <h1>Deposits</h1>
                    </div>
                    <div className="dashboard-content-table">
                        <div className="table-export">
                            <input type="search" className="table-search-input" placeholder="Search" onChange={handleSearch} />
                            <button className="btn btn-primary" onClick={exportToExcel}>Export Excel</button>
                        </div>
                        <Table dataSource={depositData} pagination={{ pageSize: 10 }} loading={isLoading}>
                            <Table.Column title="#" width={70} render={(text, record, index) => <span>{index + 1}</span>} />
                            {
                                localStorage.getItem("Role") === "Admin" &&
                                <>
                                    <Table.Column title="Username" dataIndex="UserName" />
                                    <Table.Column title="Email Address" dataIndex="Email" />
                                    <Table.Column title="Phone No." dataIndex="Phone" />
                                </>
                            }
                            <Table.Column title="Platform" render={(d) => (
                                <p>{d.platforms}</p>
                            )} />

                            <Table.Column title="Total Price" render={(d) => <p>${d.totalAmount}</p>} />
                            <Table.Column title="Your Bonus" render={(d) => <p>${d.bonusAmount}</p>} />
                            <Table.Column title="Created At" dataIndex="Date" />
                            <Table.Column title="Payment Proof" render={(d) => (
                                <a href="#" onClick={() => {
                                    setProofImage(API_LINK + "uploads/" + d.Image);
                                    setIsViewImage(true);
                                }}>
                                    <img src={API_LINK + "uploads/" + d.Image} alt="proof" style={{ width: 150, height: 80, objectFit: 'fill' }} />
                                </a>
                            )} />

                            <Table.Column title="Status" render={(u) => {
                                let color = {
                                    "Pending": "gray",
                                    "Rejected": "red",
                                    "Approved": "green",
                                    "Processing": "yellow"
                                }[u.Status] || "default";
                                return <Tag color={color}>{u.Status.toUpperCase()}</Tag>;
                            }} />

                            
                            {
                                localStorage.getItem("Role") === "Admin" &&
                                <>
                                    <Table.Column
                                        title="Bonus"
                                        key="bonusAmount"
                                        render={(record) => (
                                            <span>${parseFloat(record.bonusAmount || 0).toFixed(2)}</span>
                                        )}
                                    />



                                    <Table.Column
                                        title="Processing"
                                        render={(u) => (
                                            <Button
                                                type="primary"
                                                icon={<SiProcessingfoundation />}
                                                onClick={() => handleSubmit(u, "Processing")}
                                            />
                                        )}
                                    />

                                    <Table.Column
                                        title="Approve"
                                        render={(u) => (
                                            <Button
                                                type="primary"
                                                icon={<BiCheckDouble />}
                                                onClick={() => handleSubmit(u, "Approved")}
                                            />
                                        )}
                                    />

                                    <Table.Column
                                        title="Reject"
                                        render={(u) => (
                                            <Popconfirm
                                                title="Reject this request?"
                                                onConfirm={() => {
                                                    setCurrentData(u);
                                                    setRejectOpen(true);
                                                }}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <Button danger icon={<BiTrash />} />
                                            </Popconfirm>
                                        )}
                                    />

                                    <Table.Column
                                        title="Add Bonus"
                                        render={(u) => (
                                            <Button
                                                type="dashed"
                                                onClick={() => {
                                                    setSelectedDeposit(u);
                                                    setBonusOpen(true);
                                                }}
                                            >
                                                Add Bonus
                                            </Button>
                                        )}
                                    />
                                </>
                            }

                        </Table>

                    </div>
                </div>
            </div>
        </>
    );
}

export default DashboardDeposit;
